import { useLocation } from 'react-router-dom'
import {
  viewTypeOptions,
  projectMenuTabOptions
} from '../containers/project-menu/constants'

export const useProjectMenuListViewControl = () => {
  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)

  return {
    viewType: searchParams.get('view') ?? viewTypeOptions.LIST_VIEW,
    tab: searchParams.get('tab') ?? projectMenuTabOptions.MY_PROJECTS
  }
}
